import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function createChangeChargeBpm(requestBody) {
  return request({
    url: URL.act.changeChargeBpm.createChangeChargeBpm,
    method: 'post',
    data: requestBody
  })
}

// 查询审批流是否在执行中（目前【费用改单申请】使用）【给存在中间表的 表单类型使用】
export function getApprovingChangeChargeUuid(params) {
  return request({
    url: URL.act.changeChargeBpm.getApprovingChangeChargeUuid,
    method: 'get',
    params
  })
}

export function getChangeChargeBpm(requestBody) {
  return request({
    url: URL.act.changeChargeBpm.getChangeChargeBpm,
    method: 'post',
    data: requestBody
  })
}

export function getWorkFlowChangeCharge(params) {
  return request({
    url: URL.act.changeChargeBpm.getWorkFlowChangeCharge,
    method: 'get',
    params
  })
}

// 修改财务日期
export function batchUpdateAccountingDateBpm(jobKeys, accountingData) {
  return request({
    url: URL.act.changeChargeBpm.batchUpdateAccountingDateBpm,
    method: 'post',
    data: jobKeys,
    params: { accountingData }
  })
}
